<template>
    <div class="image-carousel slider">
        <div class="container">
            <carousel-3d
                :perspective="20"
                :display="5"
                :space="isPhone ? 120 : 200"
                :width="isPhone ? 256 : 467"
                :height="isPhone ? 324 : 586"
                :border="0"
                :controlsVisible="!isPhone"
                :controlsPrevHtml="'&#8592;'"
                :controlsNextHtml="'&#8594;'"
                @before-slide-change="onBeforeSlideChange"
                ref="carousel">
                <slide
                    :index="0"
                    data-caption="Discover how to capture stunning landscape photos<br class='hide-mobile'> in iPhone Landscape Mastery">
                    <img
                        src="https://images.iphonephotographyschool.com/38263/ILM.jpg?width=400"
                        srcset="https://images.iphonephotographyschool.com/38263/ILM.jpg?width=800 2x"
                        alt="iPhone Landscape Mastery course" />
                </slide>
                <slide
                    :index="1"
                    data-caption="Master all iPhone camera features<br class='hide-mobile'> in Capture It All">
                    <video
                        :autoplay="isCurrentSlide(1)"
                        muted
                        loop
                        playsinline
                        style="
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            border-radius: 16px;
                            box-shadow: 0px 17px 40px 10px rgba(0, 0, 0, 0.15);
                        ">
                        <source
                            src="https://cdn.iphonephotographyschool.com/cdn/cia-sales/480/Video_10_Do_you_still_use_it_like_an_old_film_camera_3x4.mp4"
                            type="video/mp4" />
                    </video>
                </slide>
                <slide
                    :index="2"
                    data-caption="Unlock the blueprint for stunning photos<br class='hide-mobile'> in iPhone Photo Academy">
                    <img
                        src="https://images.iphonephotographyschool.com/38264/IPA.jpg?width=400"
                        srcset="https://images.iphonephotographyschool.com/38264/IPA.jpg?width=800 2x"
                        alt="iPhone Photo Academy course" />
                </slide>
                <slide
                    :index="3"
                    data-caption="Discover powerful editing hacks<br class='hide-mobile'> in iPhone Editing Academy">
                    <img
                        src="https://images.iphonephotographyschool.com/38261/IEA.jpg?width=400"
                        srcset="https://images.iphonephotographyschool.com/38261/IEA.jpg?width=800 2x"
                        alt="iPhone Editing Academy course" />
                </slide>
                <slide
                    :index="4"
                    data-caption="Master your iPhone's video features<br class='hide-mobile'> in iPhone Video Academy">
                    <video
                        :autoplay="isCurrentSlide(4)"
                        muted
                        loop
                        playsinline
                        style="
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            border-radius: 16px;
                            box-shadow: 0px 17px 40px 10px rgba(0, 0, 0, 0.15);
                        ">
                        <source
                            src="https://cdn.iphonephotographyschool.com/cdn/aap/Timelapse for Tomasz.mp4"
                            type="video/mp4" />
                    </video>
                </slide>
                <slide
                    :index="5"
                    data-caption="Learn how to turn any footage into impactful videos<br class='hide-mobile'> in Video Editing Academy">
                    <video
                        :autoplay="isCurrentSlide(1)"
                        muted
                        loop
                        playsinline
                        style="
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            border-radius: 16px;
                            box-shadow: 0px 17px 40px 10px rgba(0, 0, 0, 0.15);
                        ">
                        <source src="https://cdn.iphonephotographyschool.com/cdn/aap/vea-video.mp4" type="video/mp4" />
                    </video>
                </slide>
                <slide
                    :index="6"
                    data-caption="Discover how to create an irresistible Instagram account<br class='hide-mobile'> in Instagram Academy">
                    <img
                        src="https://images.iphonephotographyschool.com/38276/Rectangle-1.jpg?width=400"
                        srcset="https://images.iphonephotographyschool.com/38276/Rectangle-1.jpg?width=800 2x"
                        alt="Instagram Academy course" />
                </slide>
                <slide
                    :index="7"
                    data-caption="Take stunning iPhone photos in any city<br class='hide-mobile'> with Urban iPhone Photography">
                    <img
                        src="https://images.iphonephotographyschool.com/38282/UIP.jpg?width=400"
                        srcset="https://images.iphonephotographyschool.com/38282/UIP.jpg?width=800 2x"
                        alt="Urban iPhone Photography course" />
                </slide>
                <slide
                    :index="8"
                    data-caption="Learn to fly your drone with confidence<br class='hide-mobile'> in Drone Mastery">
                    <img
                        src="https://images.iphonephotographyschool.com/38260/DM.jpg?width=400"
                        srcset="https://images.iphonephotographyschool.com/38260/DM.jpg?width=800 2x"
                        alt="Drone Mastery course" />
                </slide>
                <slide
                    :index="9"
                    data-caption="Learn hacks for delicious food photos<br class='hide-mobile'> in iPhone Food Photography">
                    <img
                        src="https://images.iphonephotographyschool.com/38262/IFP.jpg?width=400"
                        srcset="https://images.iphonephotographyschool.com/38262/IFP.jpg?width=800 2x"
                        alt="iPhone Food Photography course" />
                </slide>
                <slide
                    :index="10"
                    data-caption="Master the essential camera settings<br class='hide-mobile'> in Digital Camera Mastery">
                    <img
                        src="https://images.iphonephotographyschool.com/38259/DCM.jpg?width=400"
                        srcset="https://images.iphonephotographyschool.com/38259/DCM.jpg?width=800 2x"
                        alt="Digital Camera Mastery course" />
                </slide>
                <slide
                    :index="11"
                    data-caption="Take breathtaking photos in any situation<br class='hide-mobile'> with Photo Shortcuts">
                    <img
                        src="https://images.iphonephotographyschool.com/38267/PS.jpg?width=400"
                        srcset="https://images.iphonephotographyschool.com/38267/PS.jpg?width=800 2x"
                        alt="Photo Shortcuts course" />
                </slide>
                <slide
                    :index="12"
                    data-caption="Improve your shots in 3 minutes or less<br class='hide-mobile'> in Lightroom Editing Mastery">
                    <img
                        src="https://images.iphonephotographyschool.com/38266/LEM.jpg?width=400"
                        srcset="https://images.iphonephotographyschool.com/38266/LEM.jpg?width=800 2x"
                        alt="Lightroom Editing Mastery course" />
                </slide>
            </carousel-3d>

            <div class="container" :class="{ 'direction-rtl text--center': isRTL }">
                <i class="caption text--center" v-html="caption"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel3d, Slide } from '@nanoandrew4/vue3-carousel-3d';
import { helpers } from '../../helpers';

export default {
    components: {
        Carousel3d,
        Slide,
    },
    data() {
        return {
            caption:
                "Discover how to capture stunning landscape photos<br class='hide-mobile'> in iPhone Landscape Mastery",
            currentIndex: 0,
        };
    },
    computed: {
        isPhone() {
            return helpers.isPhone();
        },
        isRTL() {
            return window.App.isRTL;
        },
    },
    methods: {
        onBeforeSlideChange(index) {
            this.currentIndex = index;
            const captionData = this.$refs.carousel.$el.children[0].children[index].dataset['caption'];
            if (captionData) {
                this.caption = captionData;
            }

            // Handle video autoplay
            this.$nextTick(() => {
                const slides = this.$refs.carousel.$el.querySelectorAll('.carousel-3d-slide');
                slides.forEach((slide, slideIndex) => {
                    const video = slide.querySelector('video');
                    if (video) {
                        if (slideIndex === index) {
                            video.play();
                        } else {
                            video.pause();
                        }
                    }
                });
            });
        },
        isCurrentSlide(index) {
            return this.currentIndex === index;
        },
    },
};
</script>

<style lang="sass">
.new_sp--aap
    .image-carousel
        padding: 80px 0
        margin: -80px 0
        overflow: hidden

        .carousel-3d-slider
            margin: 0 auto
            perspective: 0 !important
            transition: all .6s ease-in-out

        &.open
            .carousel-3d-slider
                perspective: 1000px !important

            .carousel-3d-slide
                &.left-1
                    @media screen and (min-width: 568px)
                        img
                            transform: translateX(-30px)

                &.right-1
                    @media screen and (min-width: 568px)
                        img
                            transform: translateX(30px)

        .carousel-3d-container
            margin: 0
            overflow: visible
            // touch-action: none
            cursor: grab

            &:focus
                cursor: grabbing

            .carousel-3d-slide
                background: none
                overflow: visible
                will-change: transform

                img
                    max-height: 586px
                    height: 100%
                    border-radius: 16px
                    box-shadow: 0px 17px 40px 10px rgba(0, 0, 0, 0.15)
                    transform: none !important
                    transition: transform 500ms ease
                    will-change: transform


        .carousel-3d-controls
            @media screen and (min-width: 768px)
                display: none

            @media screen and (min-width: 1366px)
                display: block

            .prev,
            .next
                display: flex
                align-items: center
                justify-content: center
                height: 62px
                width: 62px
                font-size: 28px
                border-radius: 50%
                background: linear-gradient(139.81deg, rgba(235, 237, 254, 0.6) 13.11%, rgba(235, 237, 254, 0.1) 84.95%)
                box-shadow: 4px 4px 21px -1px rgba(0, 0, 0, 0.25)
                backdrop-filter: blur(20px)

                &:hover
                    opacity: 1

            .prev
                left: -30px

            .next
                right: -30px

        .caption
            position: relative
            min-height: 80px

            @media screen and (min-width: 568px)
                min-height: 52px
</style>
